export default {
  fetch: `COLLECTION_FETCH`,
  fetchSuccess: `COLLECTION_FETCH_SUCCESS`,
  fetchError: `COLLECTION_FETCH_ERROR`,
  fetchCancel: `COLLECTION_FETCH_CANCEL`,
  release: `COLLECTION_RELEASE`,
  involve: `COLLECTION_INVOLVE`,
  processingStart: `COLLECTION_PROCESSING_START`,
  processingComplete: `COLLECTION_PROCESSING_COMPLETE`,
  setObserver: `COLLECTION_SET_OBSERVER`,
  unsetObserver: `COLLECTION_UNSET_OBSERVER`,
}
